import { defineComponent as _defineComponent } from 'vue';
import { faClock } from "@fortawesome/free-regular-svg-icons";
import { faExclamation, faHdd } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BBadge } from "bootstrap-vue";
import { storeToRefs } from "pinia";
import { computed } from "vue";
import { isRegisteredUser } from "@/api";
import { useWorkflowInstance } from "@/composables/useWorkflowInstance";
import { useHistoryStore } from "@/stores/historyStore";
import { useUserStore } from "@/stores/userStore";
import TextSummary from "../Common/TextSummary.vue";
import SwitchToHistoryLink from "../History/SwitchToHistoryLink.vue";
import StatelessTags from "../TagsMultiselect/StatelessTags.vue";
import UtcDate from "../UtcDate.vue";
import WorkflowInvocationsCount from "../Workflow/WorkflowInvocationsCount.vue";
import WorkflowIndicators from "@/components/Workflow/List/WorkflowIndicators.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'WorkflowAnnotation',
    props: {
        workflowId: null,
        invocationUpdateTime: { default: undefined },
        historyId: null,
        showDetails: { type: Boolean },
        newHistoryTarget: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        const { workflow } = useWorkflowInstance(props.workflowId);
        const { currentUser } = storeToRefs(useUserStore());
        const owned = computed(() => {
            if (isRegisteredUser(currentUser.value) && workflow.value) {
                return currentUser.value.username === workflow.value.owner;
            }
            else {
                return false;
            }
        });
        const description = computed(() => {
            var _a, _b;
            if ((_a = workflow.value) === null || _a === void 0 ? void 0 : _a.annotation) {
                return (_b = workflow.value.annotation) === null || _b === void 0 ? void 0 : _b.trim();
            }
            else {
                return null;
            }
        });
        const timeElapsed = computed(() => {
            var _a;
            return props.invocationUpdateTime || ((_a = workflow.value) === null || _a === void 0 ? void 0 : _a.update_time);
        });
        const workflowTags = computed(() => {
            var _a;
            return ((_a = workflow.value) === null || _a === void 0 ? void 0 : _a.tags) || [];
        });
        return { __sfc: true, props, workflow, currentUser, owned, description, timeElapsed, workflowTags, faClock, faExclamation, faHdd, FontAwesomeIcon, BBadge, useHistoryStore, TextSummary, SwitchToHistoryLink, StatelessTags, UtcDate, WorkflowInvocationsCount, WorkflowIndicators };
    }
});
